import MyProfile from './myProfile'
export default MyProfile
